import { Box, HStack, Tag, Text, Wrap, WrapItem, Icon } from '@chakra-ui/react';
import { Tooltip } from '@/components/ui/tooltip';
import { FiInfo } from 'react-icons/fi'
import type { BandOption } from '../../../types/guidedList'

interface Props {
  label: string
  tip?: string
  options: BandOption[]
  value: string[]
  onChange: (next: string[]) => void
  nonAdjacentHint?: boolean
}

export function BandChipRow({ label, tip, options, value, onChange, nonAdjacentHint }: Props) {
  const toggle = (key: string) =>
    onChange(value.includes(key) ? value.filter(k => k !== key) : [...value, key])
  return (
    <Box>
      <HStack gap={1} mb={1}>
        <Text fontSize="sm" fontWeight="medium">{label}</Text>
        {tip && <Tooltip content={tip} showArrow><span><Icon color="gray.400" boxSize={3} asChild><FiInfo /></Icon></span></Tooltip>}
      </HStack>
      <Wrap gap={2}>
        {options.map(o => (
          <WrapItem key={o.key}>
            <Tag.Root size="md" borderRadius="full" cursor="pointer"
              variant={value.includes(o.key) ? 'solid' : 'outline'}
              colorPalette={value.includes(o.key) ? 'blue' : 'gray'}
              onClick={() => toggle(o.key)}>{o.label}</Tag.Root>
          </WrapItem>
        ))}
      </Wrap>
      {nonAdjacentHint && (
        <Text fontSize="xs" color="orange.500" mt={1}>These bands aren't adjacent — they won't narrow the universe.</Text>
      )}
    </Box>
  );
}
